const giftCardConstants = {
  CHECK_BALANCE_SUCCESS: "CHECK_BALANCE_SUCCESS",
  CHECK_BALANCE_STARTED: "CHECK_BALANCE_STARTED",
  CHECK_BALANCE_FAILED: "CHECK_BALANCE_FAILED",
  CHECK_BALANCE_RESET: "CHECK_BALANCE_RESET",
  GIFT_CARD_PAYMENT_ATTEMPT: "GIFT_CARD_PAYMENT_ATTEMPT",
  GIFT_CARD_PAYMENT_SUCCESS: "GIFT_CARD_PAYMENT_SUCCESS",
  GIFT_CARD_PAYMENT_FAILURE: "GIFT_CARD_PAYMENT_FAILURE",
  GIFT_CARD_REMOVE_ATTEMPT: "GIFT_CARD_REMOVE_ATTEMPT",
  GIFT_CARD_REMOVE_SUCCESS: "GIFT_CARD_REMOVE_SUCCESS",
  GIFT_CARD_REMOVE_FAILURE: "GIFT_CARD_REMOVE_FAILURE",
}

export default giftCardConstants
